import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {
  withTranslation,
  WithTranslationInjectedProps,
} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllGen0OrdersContent} from './AllGen0OrdersContent';
import reportPayload from './reportPayload';

interface AllGen0OrdersReportProps extends WithTranslationInjectedProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
}

export const AllGen0OrdersReport = ({
  loadingData = {},
  tt = () => '',
  showRecordPopover = noop,
}: AllGen0OrdersReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Generation 0 Orders')}
      description={tt(
        'description',
        'All orders from Clients or Coaches in your Generation Zero (may be from personal Clients or Clients from Coaches on your team).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllGen0OrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allGen0Orders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllGen0OrdersReport);
